var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-header-container"},[_c('div',{staticClass:"d-flex"},[_c('h5',{staticClass:"flex-grow-1 module-header-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }